import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Icon, type IconName } from '../ui/Icon';
import { Badge } from '../ui/Badge';

type SBItem = {
  label: string;
  path: string;
  icon: IconName;
  badge?: string;
};

type SBGroup = {
  label: string;
  items: SBItem[];
};

const GROUPS: SBGroup[] = [
  {
    label: 'Operations',
    items: [
      { label: 'Overview', path: '/overview', icon: 'home' },
      { label: 'Shipments', path: '/orders', icon: 'package' },
      { label: 'Track', path: '/track', icon: 'route' },
      { label: 'AI shipment', path: '/ai-shipment', icon: 'sparkle', badge: 'NEW' },
    ],
  },
  {
    label: 'Internal',
    items: [
      // { label: 'Internal shipments', path: '/internal-shipments', icon: 'warehouse' },
      { label: 'Address validation', path: '/address-validation', icon: 'mapPin' },
      { label: 'Contacts', path: '/contacts', icon: 'users' },
    ],
  },
  {
    label: 'Finance',
    items: [
      { label: 'Wallet', path: '/wallet', icon: 'wallet' },
    ],
  },
  {
    label: 'Account',
    items: [
      { label: 'Profile', path: '/profile', icon: 'user' },
      { label: 'API tokens', path: '/api-tokens', icon: 'key' },
    ],
  },
];

export const DashSidebar: React.FC = () => {
  const navigate = useNavigate();
  return (
    <aside className="dash-sidebar" aria-label="Dashboard navigation">
      <div className="dash-sidebar-inner">
        <button
          type="button"
          className="btn btn-blue btn-block"
          onClick={() => navigate('/shipping')}
        >
          <Icon name="plus" size={16} />
          <span>New shipment</span>
        </button>
        {GROUPS.map((g) => (
          <div key={g.label} className="sb-group">
            <div className="sb-label">{g.label}</div>
            {g.items.map((it) => (
              <NavLink
                key={it.path + it.label}
                to={it.path}
                className={({ isActive }) => `sb-item ${isActive ? 'active' : ''}`}
                end
              >
                <Icon name={it.icon} size={16} />
                <span>{it.label}</span>
                {it.badge && (
                  <Badge tone="cyan" style={{ marginInlineStart: 'auto', fontSize: 10 }}>
                    {it.badge}
                  </Badge>
                )}
              </NavLink>
            ))}
          </div>
        ))}
        <div className="sb-footer">
          <div
            className="card card-pad"
            style={{
              padding: 14,
              background: 'var(--brand-navy)',
              color: '#fff',
              border: 'none',
            }}
          >
            <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 4 }}>Need help shipping?</div>
            <div style={{ fontSize: 12, opacity: 0.8, marginBottom: 10 }}>
              Our team responds in under 2 min.
            </div>
            <a
              href="mailto:support@almaship.co"
              className="btn btn-sm"
              style={{
                background: 'var(--brand-cyan)',
                color: 'var(--brand-navy)',
                width: '100%',
                textDecoration: 'none',
              }}
            >
              <Icon name="send" size={13} />
              <span>Contact support</span>
            </a>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default DashSidebar;
